import { globalSettingsBloc } from "@fl-purchase/core/global-settings";
import { datasource } from "react-flowder";

export const globalSettingsQuery = datasource(globalSettingsBloc.stream);
export type GlobalSettingsQuery = typeof globalSettingsQuery;
